module.exports = __webpack_public_path__ + "img/phone.56309ee1.svg";